module.exports = __webpack_public_path__ + "static/blog-paint-5981460b69baa30e38a921760ddfbdb8.jpg";